import {useUiLayoutStore} from '@frontend/stores'

// Является ли текущий размер экрана монитором компьютера или ноутбука?
export function useIsDesktopScreen(): boolean {
    return useUiLayoutStore(
        state => state.deviceType === 'desktop'
    )
}
